import React, { useRef, useState, useEffect } from 'react'
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import { Link } from 'react-router-dom';
import "../styleResume/Resume04.css"

const Resume04 = () => {


  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  document.body.style.background = "white";

  const [Image, setImage] = useState()
  const [fname, setfname] = useState()
  const [lname, setlname] = useState()
  const [jobTitle, setjobTitle] = useState()
  const [phone, setphone] = useState()
  const [email, setemail] = useState()

  //address info
  const [street, setstreet] = useState()
  const [city, setcity] = useState()
  const [state, setstate] = useState()
  const [country, setcountry] = useState()
  const [postcode, setpostcode] = useState()

  //educational details 
  const [educationHTML, seteducationHTML] = useState()

  //summary
  const [ResumeDescription, setResumeDescription] = useState()

  //skills 
  const [ResumeSkills, setResumeSkills] = useState()

  //Experience
  const [experienceHTML, setexperienceHTML] = useState()

  //Project info
  const [projectInfoHTML, setprojectInfoHTML] = useState()

  useEffect(() => {
    //image photo 
    setImage(localStorage.getItem("profilePhoto"));

    //fetch objs from storage 
    const personalInfo = JSON.parse(localStorage.getItem("personalDetails"))
    //personal info
    if (personalInfo !== null) {
      setfname(personalInfo.firstname)
      setlname(personalInfo.lastname)
      setjobTitle(personalInfo.jobtitle)

      //contact info
      setphone(personalInfo.phone)
      setemail(personalInfo.email)

      //address info
      setstreet(personalInfo.address)
      setcity(personalInfo.city)
      setstate(personalInfo.state)
      setcountry(personalInfo.country)
      setpostcode(personalInfo.postcode)
    }

    //educational info
    const education = JSON.parse(localStorage.getItem("Education"));
    populateEducation(education)

    //summary
    setResumeDescription(localStorage.getItem("ResumeDescription"));

    //Experience
    const experience = JSON.parse(localStorage.getItem("ProfessionalExperience"))
    populateExperience(experience);

    //skills
    const skills = JSON.parse(localStorage.getItem('skills'));
    populateSkills(skills)

    //project Info
    const projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
    populateProject(projectInfo);
  }, [])

  const populateSkills = (skills) => {
    if (skills[0].skill !== "") {
      setResumeSkills(
        <>
          <div className="boxt03" id="Skillst03">
            <h3 className="titlet04" id="Skillstitlet04">Skills</h3>
            <ul className='skilllistt04'>

              {skills.map((sk, index) => (
                <li className="listitemt04">{sk.skill}</li>

              ))}
            </ul>
          </div>
        </>
      )
    }
  }

  const populateExperience = (experience) => {
    if (experience[0].WorkSummary !== "" || experience[0].StartDate !== "" || experience[0].PositionTitle !== "" || experience[0].EndDate !== "" || experience[0].ComponyName !== "") {
      setexperienceHTML(
        <>

          <h3 className="titlet04" id="expertitlet04">Experience</h3>
          <div className="experienceblock">
            {experience.map((exp, index) => (
              <div key={index}>
                <div>
                  <div className="jobtitlet04">
                    <label>{exp.PositionTitle}</label>
                  </div>
                  <div className="durationt04">
                    Date :<span className="startdatet04">{exp.StartDate}</span><span> to </span><span className="lastdatet04">{exp.EndDate}</span>
                  </div>
                  <div className='companynamet04'>
                    <span>{exp.CompanyName}</span>
                  </div>
                  <div className="descriptiont04">{exp.WorkSummary}</div>


                </div>
              </div>
            ))}
          </div>

        </>
      )
    }
  }

  const populateEducation = (education) => {
    if (education[0].schname !== "" || education[0].schloc !== "" || education[0].field !== "" || education[0].edustrdate !== "" || education[0].eduendate !== "" || education[0].deg !== "") {
      seteducationHTML(
        <>
          <h3 className="titlet04" id="educationtitlet04" >Education</h3>
          <ul class="rightsidelist1t04">
            {education.map((edu, index) => (
              <li id={index}>
                <div>
                  <h4><span>{edu.deg}</span> in <span>{edu.field}</span></h4>
                </div>
                <div><span>{edu.edustrdate}</span> - <span>{edu.eduendate}</span></div>
                <div>{edu.schname} <span><span>(</span>{edu.schloc}<span>)</span></span></div>
              </li>

            ))}
          </ul>
        </>
      )
    }
  }

  const populateProject = (projectInfo) => {
    if (projectInfo[0].projectTitle !== "" || projectInfo[0].projectDesc !== "") {
      setprojectInfoHTML(
        <>
          <div className="boxt04" id="projectt04">
            <h3 className="titlet04" id="protitt04" >Project</h3>
            <div className="projectsListt04">
              {projectInfo.map((prj, index) => (
                <div className="Pro1t03">
                  <div className="protitlet03"></div>
                  <div className="prodescript03"></div>


                  <div className="Pro1t04">
                    <div className="protitlet04">{prj.projectTitle}</div>
                    <div className="prodescript04">{prj.projectDesc}</div>

                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )
    }
  }


  const table = document.getElementById('resumet04');

  const downloadImage = () => {
    html2canvas(table).then(function (canvas) {
      const link = document.createElement('a');
      link.download = 'business.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  }
  return (<>
    <div className="containert04">
      <div className="resumet04" id='resumet04' ref={componentRef}>
        <div className='upperpartt04'>
          <div className='imgcontainert04'>
            <img className='userPhotot04' src={Image} alt="" />
          </div>
          <div className="upperleftt04">

            <div className="subupperleftt04">
              <div className='fullnameAndPostt04'>
                <div className='namet04'>
                  <span className='fullNamet04'><span className='fullNamet03'><span>{fname}</span>&nbsp;<span>{lname}</span></span></span>
                </div>
                <div className='positiont04'>
                  <span className='post04'>{jobTitle}</span>
                </div>
              </div>
              <div className='boxt04' id="contactinfot04" >
                <ul classname="leftsidelistt04">
                  <li>
                    <span className="icont04" id="icon1t04"><i class="fa fa-phone" aria-hidden="true"></i></span>
                    <span className="text1t04">{phone}</span>
                  </li>
                  <li className='list2t04'>
                    <span className="icont04" id="icon2t04"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                    <span className="text2t04">{email}</span>
                  </li>
                  <li className='list3t04'>
                    <span className="icont04" id="icon3t04"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                    <div className='addrest04'>
                      <span className="text3t04" ><span className="text4t03" ><span>{street}</span>, <span>{city}</span><span>, </span><span>{state}</span>, <span>{country}</span>&nbsp;(<span>{postcode}</span>)</span></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
        <div className="lowerpartt04">

          <div className="leftt04">
            <div className="boxt04" id="summaryboxt04" >
              <h3 className="titlet04" id="summarytitlet04">Summary</h3>
              <div id="summaryt04" >{ResumeDescription}</div>
            </div>

            <div className="boxt04" id="experiencet04" >
              {/* <h3 className="titlet04" id="expertitlet04">Experience</h3>
              <div className="experienceblock">
                <div className="jobtitlet04">
                  <label>Full stack developer</label>
                </div>
                <div className="durationt04">
                  <span className="startdatet04">2021</span><span>-</span><span className="lastdatet04">present</span>
                </div>
                <div className='companynamet04'>
                  <span>infosys | </span><span>123,pune shivaji road</span>
                </div>
                <div className="descriptiont04">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cumque fugit praesentium quisquam </div> */}



              {/* </div> */}
              {experienceHTML}
            </div>
            {/* <div className="boxt04" id="projectt04"> */}
            {/* <h3 className="titlet04" id="protitt04" >Project</h3>
              <div className="projectsListt04">
                <div className="Pro1t04">
                  <div className="protitlet04">data structure library</div>
                  <div className="prodescript04">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, vero?</div>
                </div>
                
              </div> */}
            {projectInfoHTML}
            {/* </div> */}
          </div>

          <div className="rightt04">
            <div className='boxt04' id="Educationt04">
              {/* <h3 className="titlet04" id="educationtitlet04" >Education</h3>
              <ul class="rightsidelist1t04">
                <li>
                  <div>
                    <h4>Masters degree in computer science</h4>
                  </div>
                  <div>2011-2013</div>
                  <div>d.y.patil university</div>
                  <div>123 Anywhere st, Any city</div>
                </li>
                
              </ul> */}
              {educationHTML}
            </div>

            <div className="boxt04" id="Skillst04">
              {/* <h3 className="titlet04" id="Skillstitlet04">Skills</h3>
              <ul className='skilllistt04'>
                <li className="listitemt04">problem solving</li>
               
              </ul> */}
              {ResumeSkills}
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* buttons to print the document */}
    <div className="container" style={{ "width": "100%", "display": "flex", "flexDirection": "row", "alignItems": "center", "justifyContent": "center", marginTop: "40px", "gap": "30px" }}>


      <Link to="/resumeform1" k><button id='eidtForm' type="button" className="btn btn-success business01-btn">EDIT FORM</button></Link>
      <button id='mybtn' onClick={handlePrint} type="button" className="btn btn-success business01-btn">Download PDF</button>
      <button onClick={downloadImage} type="button" className="btn btn-success business01-btn">Download Image</button>

    </div>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        fontFamily: "kanit",
        marginBottom: "20px",
        marginTop: "30px"

      }}
    >
      <Link
        to="/resume03"
        class="btn btn-outline-danger"
        style={{ marginRight: "50px", width: "180px", fontSize: "18px" }}
      >
        Back
      </Link>

      <Link
        to="/resume04"
        class="btn btn-outline-success"
        style={{ width: "180px", fontSize: "18px" }}
      >
        Next
      </Link>
    </div>
  </>
  )
}

export default Resume04